import { Links, Meta, Outlet, Scripts, ScrollRestoration, useLoaderData } from '@remix-run/react';

import './index.css';
import { data, LoaderFunctionArgs, redirect } from '@remix-run/node';
import { deviceTrackingCookie, getCookieValue, getOrCreateDeviceTrackingId, sessionCookie } from '@server/configuration';
import { CookiePreference } from '@components';
import { useEffect, useState } from 'react';
import { mixpanelService } from '@utilities';
// import {DisplayNotificaionProvider} from "@providers";
// import { deviceTraackingCookie, getOrCreateDeviceTrackingId } from "@singularis-labs/hfw-app-common";

export type RootLoaderData = {
  // Add other root-level data here
};

/* export const meta: MetaFunction = () => {
  return [
    {
      title: "Business Growth Tools & Frameworks for Indian SMBs | HowFrameworks",
      description: "Explore curated business frameworks, digital tools, and a focussed WhatsApp community tailored for Indian SMBs. Overcome challenges, streamline operations, and accelerate growth with HowFrameworks.com"
    },
    { property: "og:type", content: "website" },
    { property: "og:site_name", content: "HowFrameworks" },
  ];
}
 */
export function Layout({ children }: { children: React.ReactNode }) {
  const loaderData = useLoaderData<typeof loader>();

  const { userId, isAuthenticated, deviceId, isSubscribed, mixPanelId, name, phone } = useLoaderData<typeof loader>();

  // Initialize Mixpanel immediately during render
  // This runs during every render, but Mixpanel's init is idempotent
  // (it won't re-initialize if already initialized)
  if (typeof window !== 'undefined' && mixPanelId) {
    mixpanelService.init(mixPanelId, loaderData.deviceId, isAuthenticated, {
      debug: false,
      verbose: false,
      track_pageview: false,
      persistence: 'localStorage',
    });
    if (isAuthenticated) {
      mixpanelService.identify(userId, name, phone, isSubscribed, deviceId);
    }
  }

  /*  const render = <DisplayNotificaionProvider>
     {children}
   </DisplayNotificaionProvider>;// : children; */

  const [cookie, setCookie] = useState<boolean>(false);

  useEffect(() => {
    setTimeout(() => {
      setCookie(loaderData?.isCookiePreference ?? false);
    }, 5000);
  }, [loaderData?.isCookiePreference]);

  /*  useEffect(() => {
     if (loaderData.mixPanelId && typeof window !== 'undefined') {      
      mixpanelService.init(loaderData.mixPanelId, {
        debug: false,
        verbose: false,
        track_pageview: false,
        persistence: 'localStorage',               
      });
    }
  }, []); */

  return (
    <html lang="en">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>Business Growth Tools & Frameworks for Indian SMBs | HowFrameworks</title>
        <meta
          name="description"
          content="Explore curated business frameworks, digital tools, and a focussed WhatsApp community tailored for Indian SMBs. Overcome challenges, streamline operations, and accelerate growth with HowFrameworks.com"
        />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="HowFrameworks" />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link href="https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap" rel="stylesheet"></link>
        <link rel="apple-touch-icon" sizes="180x180" href="/favicon/apple-touch-icon.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="/favicon/favicon-16x16.png" />
        <link rel="manifest" href="/favicon/site.webmanifest"></link>

        {/* Organization Schema JSON-LD */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'Organization',
              name: 'HowFrameworks',
              url: 'https://www.howframeworks.com',
              logo: 'https://www.howframeworks.com/logo.png',
              sameAs: ['https://twitter.com/howframeworks', 'https://www.linkedin.com/company/howframeworks', 'https://github.com/howframeworks'],
              contactPoint: {
                '@type': 'ContactPoint',
                contactType: 'customer service',
                email: 'help@howframeworks.com',
              },
            }),
          }}
        />

        {/* Website Schema JSON-LD */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'WebSite',
              name: 'HowFrameworks',
              url: 'https://www.howframeworks.com',
              potentialAction: {
                '@type': 'SearchAction',
                target: 'https://www.howframeworks.com/knowledge-hub/resources/books?q={search_term_string}',
                'query-input': 'required name=search_term_string',
              },
            }),
          }}
        />
        <Meta />
        <Links />
      </head>
      <body
      /* style={{
        backgroundImage: `url(${background})`,
        backgroundPosition: "center center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%",
      }} */
      >
        <div className="flex flex-col w-full h-full m-0 p-0 bg-transparent  ">
          {/* <div className="w-[90%] px-4 py-6 flex items-center gap-x-2">
            <NavLink to="">
              <img src={brand_logo} alt="logo" className="max-w-96 ml-24 h-9" />
            </NavLink>
            <span className="flex-1"></span>
            <NavLink className="header-login-btn" to="login">Log in</NavLink>
            <NavLink className="header-start-assessment" to="assessment">
              Start Assessment
            </NavLink>
          </div> */}
          {children}
          {/* <div className="flex flex-col w-full items-start justify-center min-h-72 px-20 py-20">
            <div className="mb-5">
              <img src={logo} alt="logo" className="max-w-80 block" />
              <p className="text-subtext text-[#98A2B3] mt-8">
                Equip yourself with tools for long-term growth of <br /> your
                business
              </p>
            </div>
            <p className="text-subtext text-[#98A2B3]">
              Copyright © MITTELSTAND BUSINESS SOLUTIONS PRIVATE LIMITED. All
              rights reserved
            </p>
          </div> */}
          {/* <Footer /> */}
          {cookie ? <CookiePreference deviceId={loaderData.deviceId} isMobile={loaderData.isMobile} onSelection={() => setCookie(false)} /> : ''}
        </div>
        <ScrollRestoration
          getKey={location => {
            const paths = ['/knowledge-hub/resources/books', '/knowledge-hub/resources/videos', '/knowledge-hub/resources/articles'];
            return paths.includes(location.pathname)
              ? // home and notifications restore by pathname
                location.pathname
              : // everything else by location like the browser
                location.key;
          }}
        />

        <script
          dangerouslySetInnerHTML={{
            __html: `window.__ENV__ = ${JSON.stringify({
              API_URL: loaderData.apiUrl,
            })};`,
          }}
        />

        <Scripts />
        {/* Google tag (gtag.js) */}
        <script async src="https://www.googletagmanager.com/gtag/js?id=G-QCP7EYWT82"></script>

        <script type="text/javascript">
          {`
          window.dataLayer = window.dataLayer || [];
            function gtag(){
              dataLayer.push(arguments);
            }
            gtag('js', new Date());
            gtag('config', 'G-QCP7EYWT82');
          `}
        </script>
      </body>
    </html>
  );
}

export default function App() {
  return <Outlet />;
}

export async function loader({ request, context }: LoaderFunctionArgs) {
  const deviceId = await getOrCreateDeviceTrackingId(request, context.serverContext);
  const cookie = context.serverContext.cookies.get(deviceTrackingCookie);
  const apiUrl = context.serverContext.appData.secrets.ClientApiUrl;
  const cookieResp = await context.serverContext.apiClient.customerService.GetCookieStatus(deviceId);
  const cookiePreference = cookieResp.data;

  // const apiUrl = process.env.API_URL;

  const currentId = await getCookieValue(sessionCookie, request, context.serverContext);
  if (!currentId) {
    return data(
      {
        apiUrl: apiUrl,
        isAuthenticated: context.clientContext.isAuthenticated,
        isCookiePreference: cookiePreference,
        isMobile: context.clientContext.isMobile,
        mixPanelId: context.clientContext.mixPanelId,
        deviceId: deviceId,
        name: context.clientContext.user?.name ?? '',
        phone: context.clientContext.user?.phone ?? '',
        isSubscribed: context.clientContext.user?.isSubscribed ?? false,
        userId: context.serverContext.Ids?.customerId ?? '',
      },
      {
        headers: {
          'Set-Cookie': await cookie!.serialize(deviceId),
        },
      }
    );
  }

  try {
    const resp = await context.serverContext.apiClient.identityService.ValidateAuth(currentId ?? '');

    if (!resp.data.isValid) {
      const sessCookie = context.serverContext.cookies.get(sessionCookie);
      const sessCookieVal = await sessCookie?.serialize('', {
        expires: new Date(0),
        maxAge: 0,
      });

      const headers = new Headers();
      headers.append('Set-Cookie', sessCookieVal!);
      return redirect('/', {
        headers,
      });
    }
  } catch (error) {
    const sessCookie = context.serverContext.cookies.get(sessionCookie);
    const sessCookieVal = await sessCookie?.serialize('', {
      expires: new Date(0),
      maxAge: 0,
    });

    const headers = new Headers();
    headers.append('Set-Cookie', sessCookieVal!);
    return redirect('/', {
      headers,
    });
  }

  /* const sessionVal = await getRemixSession(request, context.serverContext);
  console.log(sessionVal); */

  if (!cookie) {
    return {
      apiUrl: apiUrl,
      isAuthenticated: context.clientContext.isAuthenticated,
      isCookiePreference: cookiePreference,
      isMobile: context.clientContext.isMobile,
      mixPanelId: context.clientContext.mixPanelId,
      deviceId: deviceId,
      name: context.clientContext.user?.name ?? '',
      phone: context.clientContext.user?.phone ?? '',
      isSubscribed: context.clientContext.user?.isSubscribed ?? false,
      userId: context.serverContext.Ids?.customerId ?? '',
    };
  }

  return data(
    {
      apiUrl: apiUrl,
      isAuthenticated: context.clientContext.isAuthenticated,
      isCookiePreference: cookiePreference,
      isMobile: context.clientContext.isMobile,
      mixPanelId: context.clientContext.mixPanelId,
      deviceId: deviceId,
      name: context.clientContext.user?.name ?? '',
      phone: context.clientContext.user?.phone ?? '',
      isSubscribed: context.clientContext.user?.isSubscribed ?? false,
      userId: context.serverContext.Ids?.customerId ?? '',
    },
    {
      headers: {
        'Set-Cookie': await cookie.serialize(deviceId),
      },
    }
  );
}
